import React from 'react';
import { connect } from 'react-redux';

// components
import { Typography } from '@americanexpress/aqx-components';

// utils
import clsx from 'clsx';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';

// selectors
import { getCardTileDtm, makeGetCardTitle, makeGetLearnMoreUrl } from '../redux';

// styles
import styles from '../__styles__/cardTitle.scss?modules';

const CardTitle = ({
  shortName,
  dtmEvent,
  cardTitle,
  learnMoreUrl,
  isBottomRow
}) => {
  const clickHandler = () => {
    sendDTMClickEvent({
      ...dtmEvent,
      eventAsset: replaceStringWithVars({
        varsObject: {
          productName: shortName
        },
        string: dtmEvent.eventAsset
      })
    });
  };
  return (
    <div className={clsx(styles.container, { [styles.bottomRow]: isBottomRow })}>
      <a
        href={learnMoreUrl}
        onClick={clickHandler}
        aria-label={`Learn more about ${cardTitle}`}
      >
        <Typography Component="h2" className={styles.cardTitle}>
          {cardTitle}
        </Typography>
      </a>
    </div>
  );
};

const mapStateToProps = () => {
  const getCardTitle = makeGetCardTitle();
  const getLearnMoreUrl = makeGetLearnMoreUrl();

  return (state, { shortName }) => ({
    shortName: shortName,
    dtmEvent: getCardTileDtm(state)?.cardTitle?.dtm || {},
    cardTitle: getCardTitle(state, shortName),
    learnMoreUrl: getLearnMoreUrl(state, shortName)
  });
};

export default connect(mapStateToProps)(CardTitle);
